import script from "./home-component.vue?vue&type=script&setup=true&lang=js"
export * from "./home-component.vue?vue&type=script&setup=true&lang=js"

import "./home-component.vue?vue&type=style&index=0&id=234e4c17&scoped=true&lang=css"
import "./home-component.vue?vue&type=style&index=1&id=234e4c17&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-234e4c17"]])

export default __exports__